import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SubmissionView = ({
  data,               // main submission/candidate details
  submissionData,     // document-related data
  handleShowModal,
  handleDownload,
}) => {
  if (!data) return null;

  /* ==============================
     🔹 FILE URL NORMALIZATION
     ============================== */

  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

  const resolveFileUrl = (file) => {
    if (!file || file === "null") return null;
    if (file.startsWith("http")) return file;
    return `${FILE_BASE_URL}/${file}`;
  };

let parsedSkillMetrics = [];

try {
  if (data?.skillMetrics) {
    parsedSkillMetrics = Array.isArray(data.skillMetrics)
      ? data.skillMetrics
      : JSON.parse(data.skillMetrics);
  }
} catch (error) {
  console.error("Invalid skillMetrics JSON:", error);
}


  

  /* ==============================
     🔹 NORMALIZE ALL DOCUMENTS
     ============================== */

  const documents = {
    

    resume: resolveFileUrl(submissionData?.fileUrl),
    rtr: resolveFileUrl(submissionData?.rtR_PDFDoc),
    insights: resolveFileUrl(submissionData?.resume_Insights_Pdfdoc),
    visa: resolveFileUrl(submissionData?.visaCopyUrl),
    driving: resolveFileUrl(submissionData?.drivingLicenceUrl),
    passport: resolveFileUrl(submissionData?.passportURL),
    i94: resolveFileUrl(submissionData?.i94File),
    others: resolveFileUrl(submissionData?.othersDoc),
  };
const formatDate = (d) => d ? new Date(d).toLocaleDateString() : "";
const formatDateTime = (d) => d ? new Date(d).toLocaleString() : "";

  const hasAttachments = Object.values(documents).some(Boolean);

  /* ==============================
     🔹 DISPLAY ITEM (INLINE)
     ============================== */

  const Item = ({ icon, label, value }) =>
    value ? (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>{label}</Tooltip>}>
        <p className="text-para">
          <i className={`fa ${icon} icons`}></i> {value}
        </p>
      </OverlayTrigger>
    ) : null;

  return (
    <div className="card shadow-lg mt-2 pl-5 pr-5 pt-3" style={{ border: "none" }}>
      {/* ================= BASIC DETAILS ================= */}
      <div className="row">
        <div className="col-md-6">
         <Item icon="fa-user" label="Full Name" value={data.fullName} />
<Item icon="fa-envelope" label="Email" value={data.email} />
<Item icon="fa-phone" label="Mobile" value={data.mobileNumber} />
<Item icon="fa-calendar" label="Date of Birth" value={formatDate(data.dob)} />
<Item icon="fa-map-marker" label="Address" value={data.address} />
<Item icon="fa-venus-mars" label="Gender" value={data.gender} />
<Item icon="fa-heart" label="Marital Status" value={data.maritalStatus} />
<Item icon="fa-calendar-check" label="Availability To Interview" value={data.availabilityToInterview} />
<Item icon="fa-calendar-plus" label="Availability To Join" value={data.availabilityToJoin} />
<Item icon="fa-map" label="Willing To Relocate" value={data.willingToRelocate} />
<Item icon="fa-location-arrow" label="Preferred Location" value={data.preferLocation} />
<Item icon="fa-money-bill" label="Bill Rate" value={data.billRate} />
<Item icon="fa-credit-card" label="Pay Rate" value={data.payRate} />
<Item icon="fa-bullhorn" label="Marketing Status" value={data.marketingStatus} />
<Item icon="fa-user-check" label="Assigned Bench Sales" value={data.assignBenchSaleUser} />

         
{/* 🔹 Skill Metrics */}
{parsedSkillMetrics.length > 0 && (
  <div className="mt-3">
    <h5 style={{ color: "#00a7ac" }}>Skill Metrics</h5>

    {parsedSkillMetrics.map((item, index) => (
      <p className="text-para" key={index}>
        <i className="fa fa-star icons"></i>{" "}
        <strong>{item.Skill}</strong>
        {" "}({item.YearsOfExp} yrs) – Rating: {item.Rating}/5
      </p>
    ))}
  </div>
)}


        </div>

        <div className="col-md-6">
         <Item icon="fa-briefcase" label="Job Role" value={data.jobRoleName} />
<Item icon="fa-id-badge" label="Job Title" value={data.jobTitleName || data.jobTitleID} />
<Item icon="fa-users" label="Candidate Type" value={data.candidateType} />
<Item icon="fa-tasks" label="Client Status" value={data.clientStatus} />
<Item icon="fa-flag" label="Priority" value={data.priority} />
<Item icon="fa-cogs" label="Technical Skill" value={data.technicalSkill} />
<Item icon="fa-clock" label="Experience" value={data.experience} />
<Item icon="fa-building" label="Work Mode" value={data.workMode} />
<Item icon="fa-user-tie" label="Current Role" value={data.currentRole} />
<Item icon="fa-building" label="Employer Name" value={data.employerName} />
<Item icon="fa-graduation-cap" label="Highest Education" value={data.highestEducation} />
<Item icon="fa-book" label="Course Name" value={data.courseName} />
{data.linkedInUrl && (
  <p className="text-para">
    <i className="fa fa-graduation-cap icons"></i>
    <a href={data.linkedInUrl} target="_blank" rel="noreferrer">
      View LinkedIn Profile
    </a>
  </p>
)}

{data.customAssessmentLink && (
  <p className="text-para">
    <i className="fa fa-video icons"></i>
    <a href={data.customAssessmentLink} target="_blank" rel="noreferrer">
      View Assessment Recording
    </a>
  </p>
)}

        </div>
      </div>

      {/* ================= ATTACHMENTS ================= */}
      {hasAttachments && (
        <>
          <h5 style={{ color: "#00a7ac", marginTop: 20 }}>Attachments</h5>

          {/* Resume */}
          {documents.resume && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Resume</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Resume", documents.resume);
                }}>
                  <i className="fa fa-file-alt icons"></i> View Resume
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.resume);
                }}>
                  <i className="fa fa-download icons"></i> Download Resume
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* RTR */}
          {documents.rtr && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>RTR</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("RTR_PDF", documents.rtr);
                }}>
                  <i className="fa fa-file-pdf icons"></i> View RTR
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.rtr);
                }}>
                  <i className="fa fa-download icons"></i> Download RTR
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* Resume Insights */}
          {documents.insights && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Resume Insights</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Resume_Insights_Pdf", documents.insights);
                }}>
                  <i className="fa fa-file-pdf icons"></i> View Resume Insights
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.insights);
                }}>
                  <i className="fa fa-download icons"></i> Download Resume Insights
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* Visa Copy */}
          {documents.visa && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Visa Copy</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Visa Copy", documents.visa);
                }}>
                  <i className="fa fa-id-card icons"></i> View Visa Copy
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.visa);
                }}>
                  <i className="fa fa-download icons"></i> Download Visa Copy
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* Driving Licence */}
          {documents.driving && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Driving Licence</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Driving Licence", documents.driving);
                }}>
                  <i className="fa fa-car icons"></i> View Driving Licence
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.driving);
                }}>
                  <i className="fa fa-download icons"></i> Download Driving Licence
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* Passport */}
          {documents.passport && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Passport</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Passport", documents.passport);
                }}>
                  <i className="fa fa-passport icons"></i> View Passport
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.passport);
                }}>
                  <i className="fa fa-download icons"></i> Download Passport
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* I-94 */}
          {documents.i94 && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>I-94</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("I-94", documents.i94);
                }}>
                  <i className="fa fa-file icons"></i> View I-94
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.i94);
                }}>
                  <i className="fa fa-download icons"></i> Download I-94
                </a>
              </p>
            </OverlayTrigger>
          )}

          {/* Others */}
          {documents.others && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Others</Tooltip>}>
              <p className="text-para">
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleShowModal("Others", documents.others);
                }}>
                  <i className="fa fa-folder icons"></i> View Others
                </a>
                &nbsp;|&nbsp;
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  handleDownload(documents.others);
                }}>
                  <i className="fa fa-download icons"></i> Download Others
                </a>
              </p>
            </OverlayTrigger>
          )}
        </>
      )}
    </div>
  );
};

export default SubmissionView;
